export const SIGN_POPUP_WIDTH = 390;
export const SIGN_POPUP_HEIGHT = 650;
export const THEME_CONSTANT_COLOR_BRAND = "#471be8";
export const THEME_CONSTANT_COLOR_DARK = "#101046";
export const THEME_CONSTANT_RED_COLOR = "#e25252";
export const THEME_CONSTANT_GREEN_COLOR = "#8bdaa1";
export const THEME_CONSTANT_BADGE_GREY_COLOR = "rgba(116,117,126,0.67)";
export const THEME_SMALL_WINDOW_WIDTH_MAX = 600;
